// extracted by mini-css-extract-plugin
module.exports = {"container":"ClickAndCollectPreCountdownMessage_container__JRUto","message":"ClickAndCollectPreCountdownMessage_message__uBaYk"};